 <template>
  <div class="container" style="font-size:1.1em;color:#888;padding-top:15px;margin-top:15px;padding-bottom:35px;border-bottom:0px dashed #ddd;background-color:#fff;">

        <div class="row">
          <div class="col-lg">
            <p>Geofolio uses open access geodata from the following organizations:</p>
          </div>
        </div>

        <div class="row align-items-center">
          <div class="col">
            <img src="../../assets/dataproviders/nasa.png" class="img-fluid"  style="padding:0px 30px;"  />
          </div>
          <div class="col">
            <img src="../../assets/dataproviders/esa.png" class="img-fluid"  style="padding:0px 5px;"  />
          </div>
          <div class="col">
            <img src="../../assets/dataproviders/isric.svg" class="img-fluid" style="padding:0px 0px;" />
          </div>
          <div class="col">
            <img src="../../assets/dataproviders/fao.svg" class="img-fluid" style="padding:0px 25px;" />
          </div>
          <div class="col">
            <img src="../../assets/dataproviders/usgs.svg" class="img-fluid" style="padding:0px 10px; "/>
          </div>
          
          <div class="col">
            <img src="../../assets/dataproviders/jrc.png" class="img-fluid" />
          </div>
          
        </div>
    </div>
</template>

<script>
/* eslint-disable */

export default {
  data() {
    return {
    }
  },
  components: {},
  name: 'Accreditation'
}
</script>

<style>
</style>

<style scoped>
</style>
